/**
 * Клиентские коды ошибок для ответа `__js_web_exception` в WS js-request.
 */
export const JS_WEB_ERROR_CODES = {
  GENERIC_CLIENT_ERROR: 10000,
  UNKNOWN_HANDLER: 10001,
  INVALID_REQUEST_PAYLOAD: 10002,
  TIMEOUT_OR_CANCELLED: 10003,
  RUNTIME_ERROR: 10004,
} as const

export type JsWebErrorCode = (typeof JS_WEB_ERROR_CODES)[keyof typeof JS_WEB_ERROR_CODES]
